import React, { createContext, useCallback, useContext, useState } from 'react';
import { Content, Lesson } from '../../../../types';

export type SelectionLevel = 'Program' | 'Lesson' | 'Content' | undefined;

type EditCourseContextType = {
  program: any | undefined;
  setProgram: (program: any) => void;
  lesson: Lesson | undefined;
  setLesson: (lesson: Lesson | undefined) => void;
  content: Content | undefined;
  setContent: (content: Content | undefined) => void;
  selectionLevel: SelectionLevel;
  setSelectionLevel: (level: SelectionLevel) => void;
};

const noop = () => void 0;

const defaultContext: EditCourseContextType = {
  program: undefined,
  setProgram: noop,
  lesson: undefined,
  setLesson: noop,
  content: undefined,
  setContent: noop,
  selectionLevel: undefined,
  setSelectionLevel: noop,
};

const EditCourseContext = createContext<EditCourseContextType>(defaultContext);

type Props = {
  children: React.ReactNode;
}
export const EditCourseProvider = (props: Props) => {
  const { children } = props;
  const [program, setProgramContent] = useState<any | undefined>();
  const [lesson, setLesson] = useState<Lesson | undefined>();
  const [content, setContent] = useState<Content | undefined>();
  const [selectionLevel, setSelectionLevel] = useState<SelectionLevel>();

  const setProgram = useCallback((p: any) => {
    setProgramContent(p);
  }, []);
  return (
    <EditCourseContext.Provider value={{
      program,
      setProgram,
      lesson,
      setLesson,
      content,
      setContent,
      selectionLevel,
      setSelectionLevel,
    }}>
      {children}
    </EditCourseContext.Provider>
  );
};

export const useEditCourse = () => useContext(EditCourseContext);
